<template>
  <a class="text-decoration-none" data-slot="default" v-if="!isObject()" :href="compileHref()" :target="target">
    <slot>link mix it web</slot>
  </a>
  <router-link class="text-decoration-none" data-slot="default" v-else :to="compileHref()" :target="target">
    <slot>link mix it web</slot>
  </router-link>
</template>

<script>
export default {
  name: "m-a",
  props: {
    href: {
      default: 'https://mixitweb.com'
    },
    target: {
      default: '_self'
    }
  },
  methods: {
    isObject() {
      if (typeof this.href == 'object') return true
      let item = this.href.trim();
      if (item.length !== 0) {
        return item[0] == '{' || item[0] == '}'
      }
      return false
    },
    compileHref() {
      if (typeof this.href == 'object') return this.href
      return this.isObject() ? JSON.parse(this.href) : this.href
    }
  },
};
</script>

<style scoped>

</style>

